import React, { useEffect } from "react";
import bgImage from "../../Assets/loginpage.jpg"
import { LoginForm } from "./AuthComponents";
import { Preferences } from "@capacitor/preferences";
import toast from "react-hot-toast";
import { MESSAGES } from "./constants";

const Login = () => {

  useEffect(() => {
    const checkSessionExpired = async () => {
      const { value } = await Preferences.get({ key: "sessionExpired" });
      if (value === "1") {
        toast.error(MESSAGES.SESSION_TIMEOUT);
        await Preferences.remove({ key: "sessionExpired" });
      }
    };

    checkSessionExpired();
  }, []);

  return (
    <div className="flex">
      <div className="w-3/5 h-full hidden lg:block relative">
        <img className="w-full h-screen" src={bgImage} alt="background" />
      </div>
      <div className="w-full lg:w-2/5 ">
        <LoginForm />
      </div>
    </div>
  );
};

export default Login;
